import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';

const APP_PREFIX = environment.storagePrefix;

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {
  constructor() {
  }

  static loadSessionInitialState() {
    return Object.keys(sessionStorage).reduce((state: any, storageKey) => {
      if (storageKey.includes(APP_PREFIX)) {
        const stateKeys = storageKey
          .replace(APP_PREFIX, '')
          .toLowerCase()
          .split('.')
          .map(key =>
            key
              .split('-')
              .map((token, index) =>
                index === 0
                  ? token
                  : token.charAt(0).toUpperCase() + token.slice(1)
              )
              .join('')
          );
        let currentStateRef = state;
        stateKeys.forEach((key, index) => {
          if (index === stateKeys.length - 1) {
            currentStateRef[key] = JSON.parse(sessionStorage.getItem(storageKey));
            return;
          }
          currentStateRef[key] = currentStateRef[key] || {};
          currentStateRef = currentStateRef[key];
        });
      }
      return state;
    }, {});
  }

  setItem(key: string, value: any) {
    sessionStorage.setItem(`${APP_PREFIX}${key}`, JSON.stringify(value));
  }

  getItem(key: string) {
    return JSON.parse(sessionStorage.getItem(`${APP_PREFIX}${key}`));
  }

  /**
   * Questa funzione serve per salvare aggiornare un elemnto del local storage che se non esiste viene creato,
   * mentre se esiste vengono aggiornati solo gli elementi passati nel value
   *
   * @param key
   * @param value
   * @param initialState
   */
  patchItem(key: string, value: any, initialState) {
    const savedState = this.getItem(key);
    sessionStorage.setItem(`${APP_PREFIX}${key}`, JSON.stringify((!savedState) ? {...initialState, ...value} : {...savedState, ...value}));
  }

  removeItem(key: string) {
    sessionStorage.removeItem(`${APP_PREFIX}${key}`);
  }
}
